import {addMonths} from 'date-fns';

import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {getApiDateString, parseDate} from 'shared/web';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormCalculateServiceInspectionDateActionParams {
  form: UseFormReturn<BaseVehicle>;
  value: string | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for calculating the next service inspection date.
 * Uses the last service inspection date and service inspection interval in months to calculate the next date.
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance
 */
export const formCalculateServiceInspectionDateAction = (
  _context: unknown,
  params: FormCalculateServiceInspectionDateActionParams
): void => {
  const {form, value} = params;

  const lastServiceInspectionDate = parseDate(value);
  const serviceInspectionAfterMonths = form.getValues(
    `serviceIntervals.serviceInspection.replacementAfterMonths`
  );

  if (!lastServiceInspectionDate || !serviceInspectionAfterMonths) {
    return;
  }

  const nextDate = addMonths(lastServiceInspectionDate, serviceInspectionAfterMonths);

  form.setValue(
    `serviceIntervals.serviceInspection.nextServiceInspectionDate`,
    getApiDateString(nextDate),
    DEFAULT_OPTIONS
  );
};
